import IconStarFill from "@/components/icons/icon-star-fill";
import IconStarLine from "@/components/icons/icon-star-line";

interface StarRatingInputProps {
	value: number;
	onChange: (rating: number) => void;
	disabled?: boolean;
	size?: "default" | "large";
}

export default function StarRatingInput({ value, onChange, disabled = false, size = "default" }: StarRatingInputProps) {
	const iconSize = size === "large" ? "w-10 h-10" : "w-7 h-7";

	return (
		<div className="flex items-center gap-1">
			{[1, 2, 3, 4, 5].map((star) => (
				<button
					key={star}
					type="button"
					onClick={() => !disabled && onChange(star)}
					className={`p-0.5 transition-transform ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:scale-110"}`}
					aria-label={`Rate ${star} stars`}
					disabled={disabled}
				>
					{star <= value ? (
						<IconStarFill className={`${iconSize} text-yellow-400`} />
					) : (
						<IconStarLine className={`${iconSize} text-gray-300 ${!disabled && "hover:text-yellow-300"}`} />
					)}
				</button>
			))}
			{value > 0 && <span className="ml-2 text-sm text-tertiary font-medium">{value}/5</span>}
		</div>
	);
}
